/**
 * @generated SignedSource<<64ba008779bb3489d890054176388592>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IntegrationType = "AWS" | "BITBUCKET" | "BUILDKITE" | "CAPABILITIES" | "CLOUDWATCH" | "CONFLUENCE" | "CURSOR" | "DATADOG" | "DEVIN" | "DISCORD" | "ELASTICSEARCH" | "FIREHYDRANT" | "GCP" | "GCP_CLOUD_MONITORING" | "GITHUB" | "GITLAB" | "GRAFANA_CLOUD" | "INCIDENT_IO" | "JIRA" | "LANGFUSE" | "LANGSMITH" | "LINEAR" | "NEW_RELIC" | "NOTION" | "OPENSEARCH" | "OPSGENIE" | "PAGERDUTY" | "PGANALYZE" | "POSTGRESQL" | "PROMETHEUS" | "ROLLBAR" | "ROOTLY" | "SENTRY" | "SLACK" | "SNOWFLAKE" | "SOCKET" | "TEMPORAL" | "%future added value";
export type UpdateIntegrationInput = {
  credentials: string;
  description?: string | null | undefined;
  integrationId?: any | null | undefined;
  integrationType: IntegrationType;
};
export type NotionIntegrationFormUpdateIntegrationMutation$variables = {
  input: UpdateIntegrationInput;
};
export type NotionIntegrationFormUpdateIntegrationMutation$data = {
  readonly updateIntegration: {
    readonly error: string | null | undefined;
    readonly integration: {
      readonly credentials: any;
      readonly id: any;
      readonly integrationType: IntegrationType;
      readonly name: string;
    } | null | undefined;
  };
};
export type NotionIntegrationFormUpdateIntegrationMutation = {
  response: NotionIntegrationFormUpdateIntegrationMutation$data;
  variables: NotionIntegrationFormUpdateIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIntegrationPayload",
    "kind": "LinkedField",
    "name": "updateIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLIntegration",
        "kind": "LinkedField",
        "name": "integration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "integrationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "credentials",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotionIntegrationFormUpdateIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotionIntegrationFormUpdateIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0f4acd34f48f3bc485dd71ee8859d5e1",
    "id": null,
    "metadata": {},
    "name": "NotionIntegrationFormUpdateIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation NotionIntegrationFormUpdateIntegrationMutation(\n  $input: UpdateIntegrationInput!\n) {\n  updateIntegration(input: $input) {\n    integration {\n      id\n      name\n      integrationType\n      credentials\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a479599cfda35bd0925aef7f6b76494";

export default node;
